var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFileCheck = function SvgFileCheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1668 11.1167V6.3667C17.1668 4.96657 17.1668 4.2665 16.8943 3.73172C16.6547 3.26132 16.2722 2.87887 15.8018 2.63918C15.267 2.3667 14.567 2.3667 13.1668 2.3667H7.8335C6.43336 2.3667 5.7333 2.3667 5.19852 2.63918C4.72811 2.87887 4.34566 3.26132 4.10598 3.73172C3.8335 4.2665 3.8335 4.96657 3.8335 6.3667V15.0334C3.8335 16.4335 3.8335 17.1336 4.10598 17.6683C4.34566 18.1387 4.72811 18.5212 5.19852 18.7609C5.7333 19.0334 6.43336 19.0334 7.8335 19.0334H10.5002M12.1668 9.8667H7.16683M8.8335 13.2H7.16683M13.8335 6.53337H7.16683M12.5835 16.5334L14.2502 18.2L18.0002 14.45",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFileCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/file_check.a7efd86d.svg";
export { ForwardRef as ReactComponent };